// import { ref } from 'vue'

let pollingDict = {}

export default function usePolling(fun, options = {}) {
    const {
        key,
        time = 2000,
        totalTime,
        count,
        callback = () => false
    } = options

    let timer = null
    let endTime = null
    let totalCount = 0

    // const result = ref(null)
    // const error = ref(null)
    let result = null
    let error = null

    const run = () => {
        // console.log('count2:', count, totalCount)
        if (endTime && endTime <= Date.now()) {
            end()
            callback()
            return
        }
        if (count && totalCount >= count) {
            end()
            callback()
            return
        }
        totalCount++
        timer = setTimeout(() => {
            fun()
                .then((res) => {
                    result = res
                    run()
                })
                .catch((err) => {
                    error = err
                })
        }, time)
    }

    const start = () => {
        end();                      // add this line
        if (key && pollingDict[key]) {
            pollingDict[key].end()
            delete pollingDict[key]
        }
        endTime = totalTime ? Date.now() + totalTime : null
        run()
        if (key) {
            pollingDict[key] = { end }
        }
    }

    const end = () => {
        if (timer) {
            setTimeout(() => {
                clearTimeout(timer)
                timer = null
                endTime = null
                totalCount = 0
                if (key) delete pollingDict[key]
            }, 0)
        }
    }

    return {
        start,
        end,
        error,
        result,
    }
}